<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>20. Potenzial von Cloud-Lösungen</h2>
          <p></p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "AgeComp",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text: "Wie beurteilen Sie das Potenzial von Cloud-Lösungen...​"
        },
        xAxis: {
          categories: [
            "für gemeinnützige Organisationen ganz allgemein?",
            "für Ihre spezifische Organisation?"
          ],
          labels: {
            align: "left",
            reserveSpace: true,
            style: {
              fontSize: "12"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "percent",
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        colors: ["#546825", "#7d9b38", "#999", "#0391af", "#005a85"],
        series: [
          {
            name: "Sehr großes Potenzial",
            data: [43.2, 37.56]
          },
          {
            name: "Großes Potenzial",
            data: [31.39, 30.0]
          },
          {
            name: "Mittleres Potenzial",
            data: [15.25, 19.66]
          },
          {
            name: "Geringes Potenzial",
            data: [3.19, 6.08]
          },
          {
            name: "Kein Potenzial",
            data: [0.49, 1.65]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
